import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'

import { getCanvases } from '../api'
import { importKeys } from '../queryKeys'

const useGetCanvasesQuery = ({ integration }: { integration: string }) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()

  const projectId =
    content?.elements[0]?.optimization_settings?.configuration?.project_id ?? ''

  return useQuery(
    importKeys.canvas({ accountId, projectId, integration }),
    () => getCanvases({ accountId, projectId, integration }),
    {
      enabled: !!projectId,
      select: (data) => (Array.isArray(data) ? data : []),
    }
  )
}

export default useGetCanvasesQuery
